import { underscore } from '@ember/string';

import ActiveModelSerializer from 'active-model-adapter/active-model-serializer';

const FR_ONLY_ACTIVITY_ATTRS = [
  'business_relationships',
  'business_relationships_other',
  'incoming_transfers_origin',
  'outgoing_transfers_destination',
];

export default class RegisterOrganizationSerializer extends ActiveModelSerializer {
  modelNameFromPayloadKey() {
    return 'register-organization';
  }

  payloadKeyFromModelName() {
    return 'organization';
  }

  keyForAttribute(attr) {
    return underscore(attr);
  }

  attrs = {
    addressLineOne: 'address_line_1',
    addressLineTwo: 'address_line_2',
  };

  serialize(snapshot, options) {
    let json = super.serialize(snapshot, options);

    if (snapshot.attr('legalCountry') !== 'FR') {
      for (let attr of FR_ONLY_ACTIVITY_ATTRS) {
        delete json[attr];
      }
    }

    return json;
  }

  keyForRelationship(key) {
    if (key === 'owner') {
      return 'owner_id';
    }

    if (key === 'stakeholders') {
      return 'stakeholder_ids';
    }

    if (key === 'partnerRegistration') {
      return 'partner_registration_id';
    }

    return key;
  }
}
